module.exports = "pegasus/assets/blocks/column-4-theme5.png";